import { pipe } from 'pipe-and-compose';

import { Product, Promo } from '../../types';
import getProductsPrice from '../getProductsPrice';
import { defaultTo, precisionRound, prop, propOr } from '../../utils';

interface Props {
  products?: ReadonlyArray<Partial<Product>>;
  promo?: Partial<Promo>;
  [key: string]: unknown;
}

const calculatePriceWithoutPromo = pipe(defaultTo({}), prop('products'), getProductsPrice);
const calculatePriceWithPromo = pipe(prop('promo'), propOr(0, 'amount'));

const getTotalPrice = pipe(
  (props?: Props) =>
    props?.promo
      ? calculatePriceWithPromo(props)
      : calculatePriceWithoutPromo(props),
  precisionRound,
);

export default getTotalPrice;
